<div class="patch-upload-wrapper modal-main-wrapper">
    <div class="close-container" tabindex="1">
        <div class="img-container">
            <img src="../../../../assets/icons/Close.svg" (click)="cancel()">
        </div>
    </div>
    <div *ngIf="showSetServiceKeyBanner">
    <div class="content-wrapper">
        
        <div class="title-container">
            <span class="title-span">  {{"suaTitleText" | transloco}}</span>
        </div>
        <div class="title-inner-text-container">
            <span>
                {{"suaTitleInnerText" | transloco}}
            </span>
        </div>
        <div class="fileupload-wrapper">
            <span>{{"setServiceKey" | transloco}}</span>
            <div class=" fileupload-input-wrapper">                
                <input type="text" (click)="fileUpload.click()" tabindex="4" readonly required class="file-input input-controls"
                    [(ngModel)]="packageFile.name" #fileuploadControl="ngModel" placeholder="{{'filePlaceHolder' |
                    transloco}}"
                    [ngClass]="{'error': error}" />
                <input type="file" accept=".xml" class="file-input-hidden" (change)="onFileSelected($event)" #fileUpload > 
                <button class="file-upload-btn" (click)="openFileSelectWindow(fileuploadControl,fileUpload) ">
                    <div class="elipisis"></div>
                    <div class="elipisis"></div>
                    <div class="elipisis"></div>
                </button>
            </div>
            <span
                *ngIf="fileuploadControl.errors && (fileuploadControl.dirty || fileuploadControl.touched) || fileFormatIncorrect"
                class="validation">{{fileFormatIncorrect == true ? ("fileFormatIncorrect"| transloco) : ("serviceKeyRequiredValidation" |
                transloco)}}</span>
        </div>    
    </div>

    <footer>
        <div class="button-wrapper">
            <button class="action-btn white-text upload-button" tabindex="6" [disabled]="fileuploadControl.errors || setClicked || fileFormatIncorrect" (click)="setServiceKey()">
                {{"setText" | transloco}}
            </button>
            <button type="button" class="action-btn white-text" tabindex="7" (click)="cancel()">
                {{"cancelText"| transloco}}
            </button>
        </div>       
    </footer>
   </div> 
   <div *ngIf="showWarningBanner" style="width:100%">
    <div class="warning-content-wrapper">
        
        <div class="title-container">
            <img *ngIf="showWarning" width="40" height="40" src="../../../../assets/icons/icon-caution.svg" alt="warning">
            <img *ngIf="!showWarning" width="40" height="40" src="../../../../assets/icons/icon-question.svg" alt="warning">
        </div>
        <div *ngIf="showWarning" class="warning-title-inner-text-container">
            <span style="font-weight:600">
                {{"suaTitleWarningInnerText" | transloco}}
            </span>
        </div>
        <div *ngIf="showWarning" class="warningTextDescription">
            <span>{{"suaWarningTextDescription" | transloco}}</span>                     
        </div> 
        <div *ngIf="!showWarning" class="expired-title-inner-text-container">
            <span style="font-weight:600">
                {{"suaTitleWarningExpiredInnerText" | transloco}}
            </span>
        </div>
        <div *ngIf="!showWarning" class="warningTextDescription">
            <span>{{"suaWarningExpiredTextDescription" | transloco}}</span>                     
        </div>     
    </div>

    <footer>
        <div class="button-wrapper-set">
            <button class="action-btn white-text set-button" tabindex="6" (click)="openSetServiceKeyBanner()">
                {{"setServiceKeyButton" | transloco}}
            </button>
            <button class="action-btn white-text set-button" tabindex="6" (click)="cancel(serviceKeyDialogResponse.ProceedWithoutKey)">
                {{"continue" | transloco}}
            </button>
            <button type="button" class="action-btn white-text set-button" tabindex="7" (click)="cancel()">
                {{"cancelText"| transloco}}
            </button>
        </div>       
    </footer>
   </div> 
</div>